import { useEffect, useState } from 'react';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { addHomeViewModeChangeListener } from 'events/homeViewModeEvent';

export const useModeGuideFABVisibility = () => {
  const [showModeGuideFAB, setShowModeGuideFAB] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(LocalStorageKey.ModeGuideFABDismissed);
    if (dismissed !== 'true') {
      setShowModeGuideFAB(true);
    }
  }, []);

  useEffect(() => {
    const removeListener = addHomeViewModeChangeListener(() => {
      setShowModeGuideFAB(false);
    });

    return removeListener;
  }, []);

  return { showModeGuideFAB };
};
